<button 
    (click)="emitFunction()"
    [ngClass]="styleButton"
    [disabled]="disabled || isLoading"
    [style.font-size]="fontSize + 'px'"
    [style.width]="fitWidth ? 'initial' : ''">
    <span *ngIf="!isLoading">{{ textButton }}</span>
    <mat-spinner matSuffix [diameter]="12" *ngIf="isLoading"></mat-spinner>
</button>